export interface WeakCellPosition {
  cellPosition: number | null;
  modulePosition: number | null;
}

export interface LimitingCellDetection {
  firstDetectedDate: string;
  lastDetectedDate: string;
  numberDetectedDates: number;
}

export enum Recommendation {
  Monitor = 'monitor',
  Balance = 'balance',
  Replace = 'replace',
  Investigate = 'investigate',
  ManualIntervention = 'manual_intervention',
  InvestigatePcsModule = 'investigate_pcs_module',
  InvestigateString = 'investigate_string',
  Inspect = 'inspect',
  BalanceOrTakeOffline = 'balance_or_take_offline',
  ManualInterventionOrTakeOffline = 'manual_intervention_or_take_offline',
  ReplaceOrTakeOffline = 'replace_or_take_offline',
}
